import { usePropertyRemindersListQuery } from "web_myplann/Api/Reminders/usePropertyRemindersListQuery";
import { RemindersSectionView } from "web_myplann/Reminders/Components/RemindersSectionView";
import type {
	ReminderEntity,
	RemindersSectionVariant,
} from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
	variant?: RemindersSectionVariant;
};

export const PropertyRemindersSectionContent = ({ entity, variant }: Props) => {
	const { data, isLoading, isError } = usePropertyRemindersListQuery(entity.id);

	return (
		<RemindersSectionView
			entity={entity}
			reminders={data}
			isLoading={isLoading}
			isError={isError}
			variant={variant}
		/>
	);
};
